<template>
  <svg
      width="9"
      height="16"
      viewBox="0 0 8 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :style="{transform: 'rotate(12deg)'}"
  >
    <path d="M7 1L3 17" stroke="black" stroke-width="0.5"/>
    <path d="M5 1L1 17" stroke="#D8222A" stroke-width="0.5"/>
    <path d="M6 1L2 17" stroke="#767776" stroke-width="0.5"/>
  </svg>
</template>
